/*globals STATIC_URL*/
import React from 'react';
import Phone from 'react-phone-number-input';
import {
  FormFieldWithLabel as FormField,
} from 'views/FormComponents';

export const FullName = ({ errors, readOnly = {}, name, onChange }) => {
  return (
    <FormField label="Name" errors={errors.name}>
      { readOnly.name ? (
        <p className="flush break-long-words">{name}</p>
      ) : (
        <input type="text"
          autoFocus
          value={name}
          onChange={e => onChange({ name: e.target.value })}
          />
      )}
    </FormField>
  );
};

const PhoneNumber = ({
  phone,
  isInternationalNumberEnabled,
  readOnly = {},
  errors,
  onChange,
}) => {
  return (
    <FormField label="Phone Number" errors={errors.phone}>
    { readOnly.phone ? (
      <p className="flush break-long-words">{phone}</p>
    ) : (
      <div>
        { isInternationalNumberEnabled ?
          <Phone
            value={(phone && phone.indexOf('+') == 0) || !phone ? phone : `+91${phone}`}
            maxLength="25"
            country={!phone ? 'IN' : ''}
            international={false}
            flagsPath={`${STATIC_URL}assets/images/flag-icons/`}
            onKeyDown={(e) => {
              // Prevent Taking + in the Input Field, As it Breaks the Library
              if (e.shiftKey) {
                e.preventDefault();
              }
            }}
            onChange={ phone => onChange({ phone: phone })} /> :
          <input type="tel"
            value={phone}
            onChange={e => onChange({ phone: e.target.value })}
          />
        }

      </div>
    )}
    </FormField>
  );
};

export { PhoneNumber as Phone };

export const Email = ({ errors, readOnly = {}, email, onChange }) => {
  return (
    <FormField label="Email" errors={errors.email}>
      {readOnly.email ? (
        <p className="flush break-long-words">{email}</p>
      ) : (
        <input type="email"
          value={email}
          onChange={e => onChange({ email: e.target.value })}
          />
      )}
    </FormField>
  );
};



// WEBPACK FOOTER //
// ./src/payments/views/initialize/index.js